import * as React from "react";
import { createLogger } from "../../../utils/logger";

const log = createLogger("BenchmarkBadge");

/** Badge color - matches the send button (#0A8CBB) */
const BADGE_COLOR = "#0A8CBB";
const BADGE_BG = "rgba(10, 140, 187, 0.08)";
const BADGE_BG_HOVER = "rgba(10, 140, 187, 0.14)";

interface BenchmarkBadgeProps {
  benchmarkMode: boolean;
  onToggle: () => void;
}

const BenchmarkIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polyline
      points="22,12 18,12 15,21 9,3 6,12 2,12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const BenchmarkBadge: React.FC<BenchmarkBadgeProps> = ({ benchmarkMode, onToggle }) => {
  const [isPressed, setIsPressed] = React.useState(false);

  if (!benchmarkMode) return null;

  const handleClick = () => {
    log.info("Benchmark Mode badge clicked - toggling mode", {
      currentState: benchmarkMode,
      willChangeTo: !benchmarkMode,
    });

    setIsPressed(true);
    setTimeout(() => setIsPressed(false), 150);

    onToggle();
  };

  return (
    <div
      title="Benchmark Mode Active (click to disable)"
      onClick={handleClick}
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "28px",
        height: "28px",
        borderRadius: "50%",
        backgroundColor: BADGE_BG,
        color: BADGE_COLOR,
        cursor: "pointer",
        transition: "all 0.2s ease",
        transform: isPressed ? "scale(0.9)" : "scale(1)",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = BADGE_BG_HOVER;
        e.currentTarget.style.transform = isPressed ? "scale(0.9)" : "scale(1.05)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = BADGE_BG;
        e.currentTarget.style.transform = isPressed ? "scale(0.9)" : "scale(1)";
      }}
    >
      {/* Main Icon */}
      <BenchmarkIcon />

      {/* Status Dot - positioned at top-right */}
      <div
        style={{
          position: "absolute",
          top: "2px",
          right: "2px",
          width: "6px",
          height: "6px",
          borderRadius: "50%",
          backgroundColor: BADGE_COLOR,
          border: "1.5px solid white",
          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.15)",
          pointerEvents: "none",
        }}
      />
    </div>
  );
};

export default BenchmarkBadge;
